import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  HardshipRequiredDocsService,
} from '../hardship-required-docs.service';
import {
  HardshipRequiredDocsCardComponent
} from '../hardship-required-docs-card/hardship-required-docs-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { HardshipRequiredDocsCardState } from '../helpers/hardship.models';
import { QualifyingDocumentViewModel } from '../helpers/hardship.utils';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'bw-hardship-required-docs',
    imports: [
        CommonModule,
        HardshipRequiredDocsCardComponent,
        TranslateModule,
        BrightsideUiModule,
        MicroUiMoleculeModule,
        SharedDesktopModule,
    ],
    templateUrl: './hardship-required-docs.component.html',
    styleUrl: './hardship-required-docs.component.scss'
})
export class HardshipRequiredDocsComponent {

  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  hardshipRequiredDocsService = inject(HardshipRequiredDocsService);
  routeAction = this._activatedRoute.snapshot.data['routeAction'];

  cardActions: Record<
    HardshipRequiredDocsCardState,
    (doc: QualifyingDocumentViewModel) => void
  > = {
    [HardshipRequiredDocsCardState.ADD]: (doc) => {
      this.hardshipRequiredDocsService.startUpload(doc);
      // 2. open modal for file selection
      // this.openFileUploadModal(doc.key);
    },

    [HardshipRequiredDocsCardState.UPLOADING]: (_doc) => {
      // Usually no-op or disabled; user just waits
      // Could show toast: "Upload in progress"
    },

    [HardshipRequiredDocsCardState.UPLOADED]: (doc) => {
      // Delete flow (trash icon)
      this.hardshipRequiredDocsService.deleteDocument(doc);
    },

    [HardshipRequiredDocsCardState.ERROR]: (doc) => {
      // Same as ADD, but visually "Try again"
      this.hardshipRequiredDocsService.startUpload(doc);
      // this.openFileUploadModal(doc.key);
    },

    [HardshipRequiredDocsCardState.PENDING]: (doc) => {
      // No action needed for pending state
    },

    [HardshipRequiredDocsCardState.SUBMITTED]: (_doc) => {
      // No action needed for submitted state - document is already submitted
    },
  };

  constructor() {
    this.hardshipRequiredDocsService.getHardshipDocuments();
  }

  routeUser() {
  
    if (this.routeAction === 'submit') {
      this.hardshipRequiredDocsService.submitApplication();
    } else if (this.routeAction === 'confirm-request') {
      this.hardshipRequiredDocsService.setActiveView('hardship_submit_application');
      this._router.navigate(['hardship', 'review']);
    }
  }
}
